import { baseApi } from './axios';

export const getCourse = async ({ courseId }: { courseId?: string }) => {
	const response = await baseApi.get(`/course/${courseId}`);
	return response;
};

export const getPublishedItems = async ({ courseId }: { courseId?: string }) => {
	if (!courseId) {
		return { data: { publishedItems: [] } };
	}
	const response = await baseApi.get(`/published-item/${courseId}/all`);
	return response;
};

export const getPublishedItem = async ({ publishedItemId }: { publishedItemId?: string }) => {
	const response = await baseApi.get(`/published-item/${publishedItemId}`);

	return response;
};
export const startCourse = async ({ courseId }: { courseId?: string }) => {
	const response = await baseApi.get(`/course/${courseId}/start`);
	return response;
};
